import React, { Component } from 'react';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import HeaderTwo from "../elements/HeaderTwo";
import FooterTwo from "../elements/FooterTwo";

 class Error404 extends Component {
    
    render() {
        return (
            <>
                <HeaderTwo headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />
                {/* Start Page Error  */}
                <div className="error-page-inner bg_color--4">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="inner">
                                    <h1 className="title theme-gradient">404</h1>
                                    <h3 className="sub-title">Oops! Page not found</h3>
                                    <span>Head back to the homepage with the button below</span>
                                    <div className="error-button">
                                        <a className="rn-button-style--2 btn-solid" href="/">Back To Homepage</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Page Error  */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <FooterTwo /> 
            </>
        )
    }
}
export default Error404;
